import React from 'react';
import { Card, Brow, Flex, Text } from '@highereducation/hen-ui';
import { parseHtmlString } from '@de/shared/utils';
import type { StatisticHighlightConfig } from '@de/types/types';

const StatisticHighlight: React.FC<StatisticHighlightConfig> = ({
  title = 'We have over',
  statistic = '300',
  description = 'potential matches for you. Let\u2019s personalize that list some more.',
  sourceText,
}) => {
  return (
    <Card className='w-full' variant='background-white'>
      <Card.Content>
        <Flex direction='column' gap='none'>
          <Brow>{title}</Brow>
          <Text variant='d3' weight='bold' color='heading' tag='span'>
            {statistic}
          </Text>
          <Text variant='b4' color='subtext'>
            {parseHtmlString(description)}
          </Text>
        </Flex>
        {sourceText && (
          <Text variant='b5' color='subtext' className='font-bold underline'>
            {parseHtmlString(sourceText)}
          </Text>
        )}
      </Card.Content>
    </Card>
  );
};

export default StatisticHighlight;
